import { objectiveBadge } from "@/lib/businessRules";
import { Pencil } from "lucide-react";

const statusLabel = (status) => {
  const badge = objectiveBadge(status);

  if (badge.status === "OK") {
    return "En ligne";
  }
  if (badge.status === "WARN") {
    return "A surveiller";
  }
  if (badge.status === "BAD") {
    return "Sous objectif";
  }

  return "Indisponible";
};

const CeoKpisPanel = ({ cards = [], showUnavailableNote = false, onEditTarget = null }) => {
  const hasCards = cards.length > 0;

  if (!hasCards && !showUnavailableNote) {
    return null;
  }

  return (
    <section
      className="rounded-3xl border border-white/10 glass p-6"
      data-testid="pilotage-objectives-ceo-kpis"
      aria-labelledby="pilotage-objectives-ceo-kpis-title"
    >
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        KPI Pilotage
      </p>
      <h2 id="pilotage-objectives-ceo-kpis-title" className="mt-2 text-xl font-heading font-semibold text-white">
        TJM et marge
      </h2>

      {hasCards ? (
        <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {cards.map((card) => {
            const badge = objectiveBadge(card.status);

            return (
              <article
                key={card.key}
                className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 relative group"
                data-testid={`pilotage-objectives-ceo-kpi-${card.key}`}
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">{card.label}</p>
                  </div>
                  {onEditTarget && (
                    <button
                      type="button"
                      onClick={() => onEditTarget(card.metricKey)}
                      className="rounded-lg p-1.5 text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
                      title="Modifier cette cible"
                    >
                      <Pencil className="h-3.5 w-3.5" />
                    </button>
                  )}
                </div>
                <p className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                  {card.actualTitle || "Realite"}
                </p>
                <p className="mt-1 text-2xl font-semibold text-white">{card.actualLabel}</p>
                <p className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                  {card.targetTitle || "Projection (cible)"}
                </p>
                <p className="mt-1 text-sm text-slate-200">{card.targetLabel}</p>
                <p className="mt-2 text-xs text-slate-400">{card.tooltip}</p>
                <div className="mt-4 flex flex-wrap gap-3 text-xs text-slate-300">
                  <span>{card.deltaLabel}</span>
                  <span>{card.progressLabel}</span>
                </div>
                <p className={`mt-3 inline-flex rounded-full border px-2.5 py-1 text-[11px] font-semibold ${badge.toneClass}`}>
                  {statusLabel(card.status)}
                </p>
              </article>
            );
          })}
        </div>
      ) : null}

      {showUnavailableNote ? (
        <p className="mt-4 text-sm text-slate-400" data-testid="pilotage-objectives-ceo-kpis-unavailable">
          Donnees indisponibles: renseignez des cibles TJM/Marge et verifiez les donnees missions/temps pour calculer
          les valeurs actuelles.
        </p>
      ) : null}
    </section>
  );
};

export default CeoKpisPanel;
